import { render, staticRenderFns } from "./PayrollExplanationPopover.vue?vue&type=template&id=eb272a9c&scoped=true&"
import script from "./PayrollExplanationPopover.vue?vue&type=script&lang=js&"
export * from "./PayrollExplanationPopover.vue?vue&type=script&lang=js&"
import style0 from "./PayrollExplanationPopover.vue?vue&type=style&index=0&id=eb272a9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb272a9c",
  null
  
)

export default component.exports